<template>
    <div class="snackbar-hub">
        <v-snackbar v-for="(snackbar, i) in snackbars"
                    v-bind:key="snackbar.uuid"
                    v-model="snackbars[i].status"
                    :timeout="snackbar.duration"
                    :color="snackbar.type"
                    :top="snackbar.top"
                    :bottom="snackbar.bottom"
                    :left="snackbar.left"
                    :right="snackbar.right"
                    @input="snackbars.splice(i, 1)"
                    :style="{ 'padding-bottom': i * 60 + 'px' }">
            {{ snackbar.msg }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar.customFunction != null ? customFunction(snackbar.customFunction) : snackbars.splice(i, 1)">
                    {{snackbar.textClick}}
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>
<script>
    import { UrlBundles, UserInfo, EventHub } from "Libs/core";
    export default {
        data() {
            return {
                urlBundles: UrlBundles,
                userInfo: UserInfo,
                eventHub: EventHub,
                snackbars: [],
            };
        },
        mounted() {
            this.$nextTick(() => {
                this.eventHub.$on("snackbar", (data) => {
                    const { bottom, duration, left, msg, right, top, type, customFunction, textClick } = data;
                    let snackbar = {
                        bottom: bottom || false,
                        duration: duration || 6000,
                        left: left || false,
                        msg: msg || "",
                        right: right || false,
                        status: true,
                        top: top || false,
                        type: type || null,
                        uuid: this.UUID(),
                        customFunction: customFunction || null,
                        textClick: textClick || this.$t("common.close")
                    };
                    this.snackbars.push(snackbar);
                });
            });
        },
        methods: {
            UUID() {
                var dt = new Date().getTime();
                var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
                    /[xy]/g,
                    function (c) {
                        var r = (dt + Math.random() * 16) % 16 | 0;
                        dt = Math.floor(dt / 16);
                        return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
                    }
                );
                return uuid;
            },
            customFunction(operation) {

                switch (operation) {
                    case "orders-list-dashboard":

                        break;
                }
                
            }
        },
    };
</script>

<style lang="scss">
    .v-snack:not(.v-snack--absolute) {
        height: 100%;
    }
</style>